import { Component, Input, OnInit, inject } from '@angular/core';
import { ProviderCallLogsService } from 'app/core/services/provider-call-logs.service';
import { NgClass, DatePipe } from '@angular/common';
import { OfficeComponent } from '../../../shared/components/office/office.component';
import { PhoneNumberComponent } from '../../../shared/components/phone-number/phone-number.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SafeHtmlPipe } from '../../../shared/pipes/safe-html.pipe';

@Component({
    selector: 'app-npi-call-logs',
    templateUrl: './npi-call-logs.component.html',
    styleUrls: ['./npi-call-logs.component.scss'],
    imports: [OfficeComponent, NgClass, PhoneNumberComponent, MatProgressSpinner, DatePipe, SafeHtmlPipe]
})
export class NpiCallLogsComponent implements OnInit {
  private providerCallLogService = inject(ProviderCallLogsService);

  @Input() npi: string;

  providerCallLogs = [];
  loadingProviderCallLogs = true;

  ngOnInit() {
    this.loadProviderCallLogs();
  }

  highlightPhone(enteredPhone, officePhone) {
    if (enteredPhone && (enteredPhone !== officePhone)) {
      return "red-cell";
    }
    return "";
  }

  private loadProviderCallLogs() {
    this.providerCallLogService.getByNpi(this.npi).subscribe(results => {
      this.providerCallLogs = results;
      this.loadingProviderCallLogs = false;
    });
  }
}
